import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.$http = axios

let getQuery = function (name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
      return decodeURIComponent(r[2]);
  };
  return null;
};

let attr = "{type_value:yfyy_ipo_list_"+getQuery("endDate")+",type_key:operation_activity}";
document.getElementsByTagName("html")[0].setAttribute("yybp",attr);

document.addEventListener('DOMContentLoaded',()=>{
  const html = document.querySelector('html');
  let htmlwidth = document.documentElement.clientWidth || document.body.clientWidth;
  let fontSize = htmlwidth / 7.5 ;
  fontSize =fontSize > 100 ? 100 : fontSize;
  html.style.fontSize = fontSize + 'px';
})

new Vue({
  el: '#app',
  router,
  render: h => h(App),
})
